import React, { useState } from 'react';
import GoogleMapComponent from './GoogleMap';
import { COLLEGE } from '../constants';

const Footer = () => {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });

  const handleContactSubmit = (e) => {
    e.preventDefault();
    
    const { name, email, mobile, message } = contactForm;
    
    // Create mailto link
    const subject = 'Contact Form Submission from ' + name;
    const body = `Name: ${name}\nEmail: ${email}\nMobile: ${mobile}\n\nMessage:\n${message}`;
    
    const mailtoLink = `mailto:gdcbeekapur@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open default email client
    window.location.href = mailtoLink;
    
    // Show success message
    alert('Thank you for your message! Your default email client will open to send the email to gdcbeekapur@gmail.com');
    
    // Reset form
    setContactForm({
      name: '',
      email: '',
      mobile: '',
      message: ''
    });
  };

  const handleInputChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.id]: e.target.value
    });
  };

  return (
    <footer className="bg-dark text-light py-5 mt-5">
      <div className="container">
        <div className="row">
          {/* University & Education Links */}
          <div className="col-md-3 mb-4">
            <h5 className="text-warning mb-3">University & Education</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-light text-decoration-none">University</a></li>
              <li><a href="https://uphed.gov.in/HigherEduDirectorate/DefaultDir.aspx" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Higher Education</a></li>
              <li><a href="https://uphed.gov.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Uphed</a></li>
              <li><a href="https://www.ugc.gov.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">UGC</a></li>
              <li><a href="http://naac.gov.in/index.php/en/" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">NAAC</a></li>
              <li><a href="https://www.education.gov.in/en" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">MHRD</a></li>
              <li><a href="https://uprtou.ac.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">UPRTOU</a></li>
            </ul>
          </div>

          {/* Digital Services */}
          <div className="col-md-3 mb-4">
            <h5 className="text-warning mb-3">Digital Services</h5>
            <ul className="list-unstyled">
              <li><a href="https://nkn.gov.in/en/" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">National Knowledge Network</a></li>
              <li><a href="https://www.ugc.gov.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Digilocker</a></li>
              <li><a href="https://upkosh.up.nic.in/homePage1" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Koshagar</a></li>
              <li><a href="https://rajkosh.up.nic.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">IFMS</a></li>
              <li><a href="mailto:info@university.edu" className="text-light text-decoration-none">Web Mail</a></li>
              <li><a href="https://heecontent.upsdc.gov.in/Home.aspx" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">UP Higher Education Digital Library</a></li>
            </ul>
          </div>

          {/* Government & Employment */}
          <div className="col-md-3 mb-4">
            <h5 className="text-warning mb-3">Government & Employment</h5>
            <ul className="list-unstyled">
              <li><a href="https://scholarship.up.gov.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Scholarship</a></li>
              <li><a href="https://employmentnews.gov.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Employment News</a></li>
              <li><a href="https://ayodhya.nic.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Ayodhya</a></li>
              <li><a href="https://sewayojan.up.nic.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Sewayojan</a></li>
              <li><a href="http://shasanadesh.up.gov.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Shasanadesh</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-4">
            <h5 className="text-warning mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-light text-decoration-none">Home</a></li>
              <li><a href="/register" className="text-light text-decoration-none">Student Registration</a></li>
              <li><a href="/students" className="text-light text-decoration-none">View Students</a></li>
              <li><a href="/admin" className="text-light text-decoration-none">Admin Dashboard</a></li>
              <li><a href="https://www.inflibnet.ac.in" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Online Library</a></li>
              <li><a href="https://www.rmlau.ac.in/New/SyllabusNew.aspx" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">RMLAU</a></li>
              <li><a href="https://digishakti.up.gov.in/" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Digi Shakti UP</a></li>
              <li><a href="https://www.onos.gov.in/" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">ANOS</a></li>
              <li><a href="https://ukstudent.samarth.edu.in/index.php/site/login" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">Samarth Portal (Students)</a></li>
              <li><a href="https://pmevidya.education.gov.in/swayam-portal.html" className="text-light text-decoration-none" target="_blank" rel="noopener noreferrer">SWAYAM</a></li>
            </ul>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="row mt-4">
          <div className="col-12">
            <hr className="bg-light" />
            <h5 className="text-warning mb-3 text-center">Contact Us</h5>
            <div className="row">
              <div className="col-md-6">
                <form onSubmit={handleContactSubmit} className="contact-form">
                  <div className="mb-3">
                    <input 
                      type="text" 
                      className="form-control" 
                      id="name" 
                      placeholder="Your Name *" 
                      value={contactForm.name}
                      onChange={handleInputChange}
                      autoComplete="name"
                      required 
                    />
                  </div>
                  <div className="mb-3">
                    <input 
                      type="email" 
                      className="form-control" 
                      id="email" 
                      placeholder="Your Email *" 
                      value={contactForm.email}
                      onChange={handleInputChange}
                      autoComplete="email"
                      required 
                    />
                  </div>
                  <div className="mb-3">
                    <input 
                      type="tel" 
                      className="form-control" 
                      id="mobile" 
                      placeholder="Your Mobile Number *" 
                      value={contactForm.mobile}
                      onChange={handleInputChange}
                      autoComplete="tel"
                      required 
                    />
                  </div>
                  <div className="mb-3">
                    <textarea 
                      className="form-control" 
                      id="message" 
                      rows="4" 
                      placeholder="Your Message/Comment *" 
                      value={contactForm.message}
                      onChange={handleInputChange}
                      required 
                    ></textarea>
                  </div>
                  <button type="submit" className="btn btn-warning">Send Message</button>
                </form>
              </div>
              <div className="col-md-6">
                <div className="contact-info">
                  <h6 className="text-warning mb-3">Get in Touch</h6>
                  <p><strong>Email:</strong> <a href="mailto:gdcbeekapur@gmail.com" className="text-light">gdcbeekapur@gmail.com</a></p>
                  <p><strong>Address:</strong> {COLLEGE.FULL_ADDRESS}</p>
                  <p><strong>Coordinates:</strong> 26°38'09.0"N, 82°03'19.4"E</p>
                  <p><strong>Phone:</strong> +91 82998 66286</p>
                  
                  {/* Web Admin - Enhanced Design */}
                  <div className="web-admin-contact mt-4">
                    <div className="web-admin-card">
                      <div className="d-flex align-items-center mb-2">
                        <i className="fas fa-headset fa-2x text-warning me-3"></i>
                        <div>
                          <h6 className="text-warning mb-1 fw-bold" style={{ fontSize: '1rem', letterSpacing: '0.5px' }}>
                            <i className="fas fa-globe me-2"></i>Web Admin Support
                          </h6>
                          <a 
                            href="tel:+919415374934" 
                            className="web-admin-phone text-decoration-none"
                            style={{ 
                              fontSize: '1.3rem', 
                              fontWeight: '700',
                              color: '#ffc107',
                              display: 'inline-block',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            <i className="fas fa-phone-alt me-2"></i>+91 9415374934
                          </a>
                        </div>
                      </div>
                      <p className="mb-0 text-light" style={{ fontSize: '0.85rem', opacity: 0.9, marginLeft: '3.5rem' }}>
                        <i className="fas fa-clock me-1"></i>Available for technical support
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Google Maps Section */}
        <div className="row mt-4">
          <div className="col-12">
            <hr className="bg-light" />
            <h5 className="text-warning mb-3 text-center">Our Location</h5>
            <GoogleMapComponent />
          </div>
        </div>

        {/* Copyright Section */}
        <div className="row mt-4">
          <div className="col-12">
            <hr className="bg-light" />
            <div className="text-center">
              <p className="mb-0">&copy; {new Date().getFullYear()} {COLLEGE.FULL_NAME}. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        footer a:hover {
          color: #ffc107 !important;
          text-decoration: underline !important;
        }

        footer h5 {
          font-weight: 600;
          border-bottom: 2px solid #ffc107;
          padding-bottom: 8px;
          display: inline-block;
        }

        footer .row {
          display: flex;
          flex-wrap: wrap;
        }

        footer .col-md-3 {
          flex: 0 0 25%;
          max-width: 25%;
        }

        @media (max-width: 768px) {
          footer .col-md-3 {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }

        footer ul li {
          margin-bottom: 8px;
        }

        footer hr {
          opacity: 0.3;
        }

        .contact-form input,
        .contact-form textarea {
          background-color: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: white;
        }

        .contact-form input::placeholder,
        .contact-form textarea::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }

        .contact-form input:focus,
        .contact-form textarea:focus {
          background-color: rgba(255, 255, 255, 0.15);
          border-color: #ffc107;
          color: white;
          box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
        }

        .map-container {
          background: rgba(255, 255, 255, 0.1);
          padding: 20px;
          border-radius: 8px;
        }

        .contact-info p {
          margin-bottom: 10px;
        }

        .contact-info a:hover {
          color: #ffc107 !important;
        }

        /* Web Admin Contact Card - Enhanced Styling */
        .web-admin-contact {
          margin-top: 1.5rem;
        }

        .web-admin-card {
          background: linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 193, 7, 0.05) 100%);
          border: 2px solid rgba(255, 193, 7, 0.3);
          border-radius: 12px;
          padding: 20px;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(255, 193, 7, 0.1);
        }

        .web-admin-card:hover {
          border-color: rgba(255, 193, 7, 0.6);
          box-shadow: 0 6px 20px rgba(255, 193, 7, 0.2);
          transform: translateY(-2px);
        }

        .web-admin-phone {
          color: #ffc107 !important;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          transition: all 0.3s ease;
        }

        .web-admin-phone:hover {
          color: #ffd54f !important;
          text-shadow: 0 2px 8px rgba(255, 193, 7, 0.5);
          transform: scale(1.05);
        }

        .web-admin-phone i {
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }

        @media (max-width: 768px) {
          .web-admin-card {
            padding: 15px;
          }

          .web-admin-phone {
            font-size: 1.1rem !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
